import React from 'react';

const BrandLogo = ({ style, className }) => {
  return (
    <div className={`brand-logo ${className || ''}`} style={{ display: 'flex', alignItems: 'center', gap: '10px', color: 'var(--text-primary)', ...style }}>
      <svg 
        width="34" 
        height="34" 
        viewBox="0 0 34 34" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
        style={{ flexShrink: 0 }}
      >
        {/* Outer Tech Ring */}
        <circle cx="16" cy="16" r="12" stroke="currentColor" strokeWidth="3.5" strokeLinecap="round" strokeDasharray="55 15" />
        {/* The Q Tail */}
        <path d="M23 23L31 31" stroke="var(--accent-primary)" strokeWidth="4.5" strokeLinecap="round" />
        {/* Inner Node */}
        <circle cx="16" cy="16" r="4.5" fill="var(--accent-primary)" />
      </svg>
      <span style={{ 
        fontFamily: "'Outfit', sans-serif", 
        fontWeight: '800', 
        fontSize: '1.45rem', 
        letterSpacing: '-0.03em',
        color: 'inherit',
        whiteSpace: 'nowrap'
      }}>
        Quantis<span style={{ color: 'var(--accent-primary)' }}>.</span>
      </span>
    </div>
  );
};

export default BrandLogo;
